import { defineElement, FC, useElements, useProp } from '@atomify/hooks';
import { Fragment, h } from '@atomify/jsx';
import { useStylesheet } from '@utilities/hooks';

import style from './inview-indicator.scss';

export const SCROLL_INDICATOR_ACTIVE = 'inview-indicators__item--is-active';
export const SCROLL_INDICATOR_HOOK = '[js-hook-inview-indicator]';

export interface InviewIndicatorElement extends HTMLElement {
    amount: number;
    activeItem: number;
}

const InviewIndicator: FC<InviewIndicatorElement> = ({ update }) => {
    const [amount, , watchAmount] = useProp<number>('amount', 0);
    const [activeItem, , watchActiveItem] = useProp<number>('activeItem', 0);

    const indicators = useElements<HTMLSpanElement[]>(SCROLL_INDICATOR_HOOK);

    useStylesheet(style);

    watchAmount(() => {
        update();
    });

    watchActiveItem((newValue: number) => {
        if (!indicators.current) return;
        Array.from(indicators.current).forEach((indicator, index) => {
            const action = newValue === index ? 'add' : 'remove';
            indicator && indicator.classList[action](SCROLL_INDICATOR_ACTIVE);
        });
    });

    return (
        <Fragment>
            {[...new Array(amount)].map((_, index) => (
                <span
                    class={`inview-indicators__item ${
                        activeItem === index ? SCROLL_INDICATOR_ACTIVE : ''
                    } `}
                    js-hook-inview-indicator
                />
            ))}
        </Fragment>
    );
};

InviewIndicator.props = {
    amount: {
        type: Number,
        reflectToAttr: true,
    },
    activeItem: {
        type: Number,
        reflectToAttr: true,
    },
};

defineElement('inview-indicator', InviewIndicator, { useShadowDom: true });
